// src/pages/NotFoundPage.tsx
import React from "react";

function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-red-100">
      <h1 className="text-3xl text-red-600 font-bold">404 - Page Not Found</h1>
    </div>
  );
}

export default NotFoundPage;
